module.exports = __webpack_public_path__ + "img/streaming_info.d061913a.jpg";